export default __webpack_public_path__ + "fonts/e345b4b5e8559751f7a763cee5320124.svg";